function NotFoundCtrl($scope, authService, organizationService) {
  const currentUserOrganization = organizationService.getCurrentOrganization();

  $scope.currentOrganization = currentUserOrganization;
  $scope.isAuthenticated = authService.isLoggedIn();
}

NotFoundCtrl.$inject = [
  '$scope',
  'jsSdk.auth',
  'organizationService'
];

export default NotFoundCtrl;



// WEBPACK FOOTER //
// ./src/components/notFound/notFoundCtrl.js